import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

require('./assets/styles/bookchain.css');

createApp(App).component('font-awesome-icon', FontAwesomeIcon).use(router).mount('#app')